const optionData = [{
      id: 1,
      value: 'signIntention',
      label: '签署意向'
    }, {
      id: 2,
      value: 'sendData',
      label: '发送资料'
    }, {
      id: 3,
      value: 'location',
      label: '店铺选址'
    }, {
      id: 4,
      value: 'signFranchise',
      label: '签署协议'
    }, {
      id: 5,
      value: 'dissolveIntention',
      label: '解除意向'
    }, {
      id: 6,
      value: 'dissolveFranchise',
      label: '解除协议'
  }]

export default optionData